<button [uiClosingModal]="true" (click)="destroyModal()" ui-button uiIconButton="close-big" uiType="link" uiSize="default"></button>

<div ui-row uiJustify="center">
  <div class="sp-px-12" ui-col>
    <div class="sp-mb-24" *ngIf="uiType" ui-row uiJustify="center">
      <div ui-col>
        <ui-icon class="fs-72px" [uiType]="uiType" [uiTheme]="uiTheme"></ui-icon>
      </div>
    </div>
    <div ui-row uiJustify="center">
      <div ui-col>
        <h4 class="confirm-action-title text-color-gray-13 fs-30px">{{ title }}</h4>
        <p class="confirm-action-decription sp-mt-24 sp-mb-32 text-color-gray-13 fs-14px" [innerHTML]="description"></p>
      </div>
    </div>
  </div>
</div>
